import React, { useState } from "react";
import { EnvioEmailSMSActivacionCuenta } from "../actions";
import { TextBox, Button, Validator, ValidationGroup } from "devextreme-react";
import { envioEmailSMSActivacionCuenta } from "../../../../services/ValidacionIdentidad";
import { phoneNumberInsert } from "../../phoneNumberInsert";

/**
 * @description Componente para renderizar la pantalla de activación de cuentam
 * en la misma se solicita al usuario ingresar su numero de telefono y su correo electronico,
 * donde recibira el codigo de activación via SMS/Email
 * @author Tony Krikorian <tkrikoriam@achs.cl>
 * @param {*} message Mensaje de estatus de la cuenta del usuario devuelto desde el backend
 * @param {*} telefonoActivacion Numero de telefono precargado desde el backend
 * @param {*} emailActivacion Email precargado desde el backend
 * @param {*} dispatch  Redux dispatch pasado por referencia
 *
 */
const ActivacionCuenta = ({
  message,
  telefonoActivacion,
  emailActivacion,
  dispatch,
}) => {
  const [telefonoActivacionUsuario, setTelefonoActivacionUsuario] = useState(
    telefonoActivacion
  );
  const [emailActivacionUsuario, setEmailActivacionUsuario] = useState(
    emailActivacion
  );

  const [correoReenviado, setCorreoReenviado] = useState(false);
  return (
    <ValidationGroup>
      <center>
        <div className="acceso row">
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"
            style={{ margin: "5px 0" }}
          >
            <h2
              className="titulo-validacion-cuenta"
              style={{ textAlign: "center", paddingTop: 5 }}
            >
              Activación cuenta
            </h2>
            {/* <p
              className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{ fontSize: "14px", fontWeight: "bolder", color: "red" }}
            >
              {message}
            </p> */}
            <p
              className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 texto-subtitulo"
              style={{ fontSize: "14px", fontWeight: "bolder" }}
            >
              {`Ingresa los siguientes datos para activar tu cuenta`}
            </p>
          </div>
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ textAlign: "center", marginTop: "1px" }}
          >
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Teléfono <span className="label-green-requerido">*</span>
                </p>
              </h3>
              <TextBox
                id="telefono"
                mask="+56\900000000"
                useMaskedValue
                placeholder="Teléfono"
                maxLength={30}
                valueChangeEvent="keyup"
                maskInvalidMessage="Teléfono inválido"
                onValueChanged={(e) => {
                  setTelefonoActivacionUsuario(phoneNumberInsert(e.previousValue, e.value));
                }}
                value={telefonoActivacionUsuario}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Debe ingresar el numero de telefono",
                    },
                    {
                      type: "stringLength",
                      min: 8,
                      message: "El telefono debe tener minimo 9 caracteres",
                    },
                  ]}
                />
              </TextBox>
            </div>

            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Correo electrónico
                  <span className="label-green-requerido"> *</span>
                </p>
              </h3>
              <TextBox
                id="email"
                placeholder="ejemplo@email.com"
                onValueChanged={(e) => setEmailActivacionUsuario(e.value)}
                valueChangeEvent="keyup"
                maxLength={60}
                value={emailActivacionUsuario}
              >
                <Validator
                  validationRules={[
                    { type: "required", message: "Debe ingresar el email" },
                    {
                      type: "email",
                      message: "Debe ingresar un email valido",
                    },
                  ]}
                />
              </TextBox>
              <p className="input-information text-left">
                Recuerda registrar un correo electrónico y teléfono válidos.
                Siempre puedes modificar tus datos en Mi cuenta {">"} Mi perfil
                de ACHS Virtual.
              </p>
            </div>
            <Button
              text="Enviar link de activación"
              style={{ width: "100%", marginTop: "10px" }}
              type="default"
              onClick={(e) => {
                if (e.validationGroup.validate().isValid) {
                  dispatch(
                    EnvioEmailSMSActivacionCuenta(
                      {
                        Phone: telefonoActivacionUsuario,
                        Email: emailActivacionUsuario,
                        NotificationType: 3,
                      },
                      null,
                      envioEmailSMSActivacionCuenta
                    )
                  );
                  setCorreoReenviado(true);
                }
              }}
            />
            {correoReenviado && (
              <p
                className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{ marginTop: "20px", fontWeight: "bold" }}
              >
                Se ha reenviado el link de activación exitosamente
              </p>
            )}
          </div>
        </div>
      </center>
    </ValidationGroup>
  );
};

export default ActivacionCuenta;
